import React from 'react';
import { useDutchieStore, i18nFn, defaultCategories, Category } from '@springbig/shared';
import { HStack, VStack, Pressable } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';

export const ActiveFiltersList = ({
    t,
}: {
    t: i18nFn;
}) => {

    const {
        setFilters,
        filters,
        setMenuCategories,
        setBrandFilter,
        setCategoryFilter,
    } = useDutchieStore();
    const {
        button_background,
        button_text,
        section_background,
        pressable_text,
    } = useShopStyles();

    const clearFilters = (): void => {

        setMenuCategories(defaultCategories);
        setFilters(null);
        setCategoryFilter(undefined);
        setBrandFilter(undefined);
    };

    return (
        <VStack
            bg={button_background}
            pt={2}
            pb={1}
            px={2}
            alignItems={'center'}
            position={'relative'}
        >
            <Caption color={button_text} fontWeight={500}>
                { t('shop.active_filters') }
            </Caption>
            <Pressable
                position={'absolute'}
                top={2}
                right={2}
                bg={section_background}
                rounded={'sm'}
                px={1}
                onPress={clearFilters}
            >
                <Caption color={pressable_text} fontSize={10}>
                    { t('shop.clear_filters') }
                </Caption>
            </Pressable>
            <HStack
                space={2}
                alignItems={'center'}
                justifyContent={'space-evenly'}
                w={'100%'}
                flexWrap={'wrap'}
            >
                { filters?.strainType &&
                    <Caption color={button_text}>
                        { filters?.strainType?.toLowerCase() }
                    </Caption>
                }
                { filters?.effects?.map((effect, index) =>

                    <Caption key={index} color={button_text}>
                        { effect?.toLowerCase() }
                    </Caption>
                )}
                { filters?.minPrice || filters?.maxPrice ?
                    <Caption color={button_text}>
                        { t('shop.between_price_filter', [filters?.minPrice, filters?.maxPrice]) }
                    </Caption> :
                    <></>
                }
            </HStack>
            {filters?.categories && filters?.categories.map((e: Category) => <Caption key={e} color={button_text}>{e.toLowerCase().replace('_', ' ')}</Caption>)}
        </VStack>
    );
};
